import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get('next') || '/cuenta';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { const u = await login(email, password); nav(u.role === 'designer' ? '/designer' : next); }
    catch { toast.error('Credenciales inválidas'); }
    finally { setLoading(false); }
  };

  return (
    <main className="bg-stilo-bg min-h-[70vh]" data-testid="login-page">
      <div className="max-w-md mx-auto px-6 pt-16 pb-32">
        <p className="overline">Acceder</p>
        <h1 className="font-serif text-5xl mt-4">Bienvenido de nuevo.</h1>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline">Email</label>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 w-full border-b border-stilo-ink/30 py-2 bg-transparent focus:outline-none focus:border-stilo-ink" data-testid="login-email" />
          </div>
          <div>
            <label className="overline">Contraseña</label>
            <input type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 w-full border-b border-stilo-ink/30 py-2 bg-transparent focus:outline-none focus:border-stilo-ink" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-stilo w-full justify-center" data-testid="login-submit">{loading ? 'Entrando…' : 'Acceder'}</button>
        </form>
        <p className="mt-8 text-sm text-stilo-ink2">¿Aún no tienes cuenta? <Link to="/registro" className="text-stilo-ink underline">Crea una</Link></p>
      </div>
    </main>
  );
}
